import * as React from "react"

function Round({props , width , height}) {
  return (
    <svg
    width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0c.375 0 .745.02 1.11.061a1 1 0 01-.22 1.988 8 8 0 107.061 7.061 1.001 1.001 0 011.988-.22c.04.365.06.735.061 1.11 0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm-.032 5.877a1 1 0 01-.719 1.217A3.002 3.002 0 0010 13a3 3 0 002.906-2.25 1 1 0 011.936.5A5.003 5.003 0 015 10a5 5 0 013.75-4.842 1 1 0 011.218.719zm6.536-5.75a1 1 0 01.617.923v1.83h1.829a1 1 0 01.707 1.707L16.12 8.12a1 1 0 01-.707.293H13l-1.828 1.829a1 1 0 11-1.415-1.415L11.586 7V4.586a1 1 0 01.293-.707L15.414.343a1 1 0 011.09-.217m-1.383 3.337L13.586 5v1.414H15l1.536-1.535h-.415a1 1 0 01-1-1v-.416z"
        fill="#fff"
      />
    </svg>
  )
}

export default Round
